import React from 'react';
import ProfileCard from './ProfileCard';
import ProfileDetailedCard from './ProfileDetailedCard';
import ProfileReducedCard from './ProfileReducedCard';
import ContentModal from '../ContentModal';
import NotesModal from '../NotesModal';
import SingleMessageModal from '../SingleMessageModal';
import SingleShareModal from '../SingleShareModal';
import ConnectUserModal from '../ConnectUserModal';
import ShortlistModal from '../Shortlist/ShortlistModal';
import UserNavigation from '../UserNavigation';
import Select from 'react-select';
import Event from '../Event';
import moment from 'moment';
import Url from '../Url';

export default class Results extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            detailedView: false,
            pagination: null,
            users: null,
            applications: null,
            contentType: null,
            shortlistedUsers: []
        };
    }

    componentDidMount() {
        this.handlePropsUpdate(this.props);

        let detailedView = this.state.detailedView;
        let contentType = this.state.contentType;

        if (this.props.detailed) {
            this.setState({detailedView: this.props.detailed, contentType: this.props.contentType});
        } else {
            try {
                let localDetailedView = localStorage ? localStorage.getItem('mandyPref.detailedView') : null;
                let localContentType = localStorage ? localStorage.getItem('mandyPref.contentType') : null;
                detailedView = localDetailedView !== null ? JSON.parse(localDetailedView) : detailedView;
                contentType = localContentType !== null ? localContentType : contentType;
            } catch (e) {
                Bugsnag.notify('Anyone - Results@componentDidMount:', 'localStorage error', { e });
            }
    
            this.setState({ detailedView, contentType });
        }
        
    }

    componentWillReceiveProps(props) {
        this.handlePropsUpdate(props);
    }

    handlePropsUpdate(props) {
        if (props.data && props.data.pagination) {
            let applications = {};
            if (props.data.applications && props.data.applications.length > 0) {
                for (let key in props.data.applications) {
                    if (props.data.applications.hasOwnProperty(key) && props.data.applications[key] && props.data.applications[key].application_user_uid) {
                        if (typeof applications[props.data.applications[key].application_user_uid] === 'undefined') {
                            applications[props.data.applications[key].application_user_uid] = [];
                        }
                        applications[props.data.applications[key].application_user_uid].push(props.data.applications[key]);
                    }
                }
            }

            let shortlists = props.data.shortlists ? props.data.shortlists : [];

            this.setState({
                users: props.data.pagination.data,
                pagination: props.data.pagination,
                applications,
                shortlists
            }, () => {
                UserNavigation.setPageUrls(this.state.pagination.prev_page_url, this.state.pagination.next_page_url, location.href);
                UserNavigation.setUserUrls(this.state.users.map(user => {
                    return { link: user.candidateLink, uid: user.uid };
                }));
            });
        }
    }

    shortlisted(user) {
        if (user) {
            for (let key in this.state.shortlists) {
                if (this.state.shortlists.hasOwnProperty(key)) {
                    let shortlist = this.state.shortlists[key];
                    if (shortlist.users.find((shortlistUser) => (shortlistUser.uid === user.uid))) {
                        return true;
                    }
                }
            }

            if (this.state.shortlistedUsers.indexOf(user.uid) !== -1) {
                return true;
            }
        }

        return false;
    }

    cards() {
        if (this.state.users) {
            if (this.props.reduced) {
                return (
                    <div className="row">
                        {
                            this.state.users.map((user, index) => {
                                return (
                                    <div key={index} className="col-sm-6 col-lg-4 col-xl-3 simpleCardContainer">
                                        {this.reducedCard(user, index)}
                                    </div>
                                );
                            })
                        }
                    </div>
                );
            } else {
                if (this.state.detailedView && window.innerWidth >= 992) {
                    return this.state.users.map((user, index) => this.detailedCard(user, index));
                } else {
                    return (
                        <div className="row">
                            {
                                this.state.users.map((user, index) => {
                                    return (
                                        <div key={index} className="col-sm-6 col-lg-4 col-xl-3 simpleCardContainer">
                                            {this.card(user, index)}
                                        </div>
                                    );
                                })
                            }
                        </div>
                    );
                }
            }
        }
        return null;
    }

    reducedCard(user, index) {
        return (
            <ProfileReducedCard user={user} key={index} imageUrl={Url.image(user.image_uid)} />
        );
    }

    card(user, index) {
        return (
            <ProfileCard shortlisted={this.shortlisted(user)} user={user} key={index} imageUrl={Url.image(user.image_uid ? user.image_uid : user.defaultimage)} />
        );
    }

    detailedCard(user, index) {
        return (
            <ProfileDetailedCard shortlisted={this.shortlisted(user)} user={user} key={index} imageUrl={Url.image(user.image_uid ? user.image_uid : user.defaultimage)} getImageUrl={(uid, directory, ext) => Url.image(uid, directory, ext)} contentType={this.state.contentType} />
        );
    }

    numberFormat(n) {
        if (n) {
            return n.toFixed(0).replace(/./g, function (c, i, a) {
                return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
            });
        }
        return 0;
    }

    stats() {
        return this.state.pagination ? (
            <p className="mt-1 mb-1 secondary">
                <small>Showing {this.numberFormat(this.state.pagination.from)}-{this.numberFormat(this.state.pagination.to)} of {this.numberFormat(this.state.pagination.total)} candidates</small>
            </p>
        ) : null;
    }

    noteAdded(uid, content) {
        let users = this.state.users.map((user) => {
            if (user.uid === uid) {
                user.note = content;
                user.note_updated_at = moment();
            }
            return user;
        });
        this.setState({ users });
    }

    setDetailed(val) {
        this.setState({ detailedView: val }, () => {
            try {
                if (localStorage) {
                    try {
                        localStorage.setItem('mandyPref.detailedView', val);
                    } catch (e) {
                        Bugsnag.notify('Anyone - Results@setDetailed:', 'localStorage error', { e });
                    }
                }
            } catch (e) {
                Bugsnag.notify('Anyone - Results@setDetailed:', 'localStorage set error', { e });
            }

            if (this.props.onDetailedViewChange) {
                this.props.onDetailedViewChange(this.state.detailedView);
            }
        });
    }

    handleContentTypeChange(val) {
        this.setState({ contentType: val }, () => {
            try {
                if (localStorage) {
                    localStorage.setItem('mandyPref.contentType', val);
                }
            } catch (e) {
                Bugsnag.notify('Anyone - Results@handleContentTypeChange:', 'localStorage error', { e });
            }

            Event.fire('portfolioCarousel.contentType', { contentType: this.state.contentType });
        });
    }

    addUserToShortlisted(user) {
        let shortlistedUsers = this.state.shortlistedUsers;
        shortlistedUsers.push(user.uid);
        this.setState({ shortlistedUsers });
    }

    render() {
        return (
            <div>
                <div className="row mb-3 no-print">
                    <div className="col-md-6">
                        {this.stats()}
                    </div>
                    {!this.props.reduced ? (
                        <div className="col-md-6 text-right d-none d-lg-block">
                            <button type="button" className={"btn btn-secondary btn-sm mr-2" + (!this.state.detailedView ? ' active' : '')} onClick={() => this.setDetailed(false)}>
                                <i className="fa fa-th-large" aria-hidden="true"></i> Simple
                        </button>
                            <button type="button" className={"btn btn-secondary btn-sm mr-2" + (this.state.detailedView ? ' active' : '')} onClick={() => this.setDetailed(true)}>
                                <i className="fa fa-list-ul" aria-hidden="true"></i> Detailed
                        </button>
                        </div>
                    ) : null}
                </div>
                {this.props.reduced ?
                    <div>
                        <p>External Applications</p>
                        <ul>
                            <li>To increase your opportunity to reach porspective applicants Mandy allows non-members to apply for your job listing.</li>
                            <li>We are unable to verify the experience and take no responsibility for the quality of external applicants.</li>
                            <li>We strongly recommend that you request applicants to complete a Mandy profile.</li>
                        </ul>
                    </div>
                    : null}
                {!this.props.reduced && this.state.detailedView ? (
                    <div className="row">
                        <div className="col-md-2 offset-md-10 d-none d-lg-block">
                            <Select
                                name="contentType"
                                placeholder="Show: "
                                resetValue={{ value: null }}
                                clearable={false}
                                value={this.state.contentType}
                                options={[
                                    { value: null, label: 'All' },
                                    { value: 'photos', label: 'Photos' },
                                    { value: 'mediaFiles', label: 'Media Files' },
                                    { value: 'credits', label: 'Credits' }
                                ]}
                                onChange={(val) => this.handleContentTypeChange(val.value)}
                                className="Select-bootstrap mb-2"
                            />
                        </div>
                    </div>
                ) : null}
                <div className="container-fluid" style={{ paddingRight: 0, paddingLeft: 0 }}>
                    {this.cards()}
                </div>
                <ContentModal title="" content="" />
                <SingleMessageModal />
                <SingleShareModal />
                <ConnectUserModal />
                <ShortlistModal onUserShortlisted={(user) => this.addUserToShortlisted(user)} />
                <NotesModal noteAdded={(uid, content) => this.noteAdded(uid, content)} />
            </div>
        );
    }
}